import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1abb2121"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field col-12 mb-2 -ml-2 -mr-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("名前"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "block p-error text-sm"
}

import { reactive, withDefaults } from "vue";
import * as _ from "lodash";

import { ValidateError } from "async-validator";

type INewField = {
  errorFields: Record<string, ValidateError[]>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'new',
  props: {
    errorFields: null
  },
  emits: ["changingName"],
  setup(__props: any, { emit: emits }) {





const onChangingName = ({ target: { value: newName } }: { target: { value: string } }) =>
  emits("changingName", newName);

const form = reactive({
  name: "",
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_InputText, {
      modelValue: form.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
      "aria-describedby": "name-help",
      type: "text",
      size: "large",
      placeholder: "プレスホルダーテキスト",
      name: "customer_name",
      class: "mr-2 max-w-6rem font-normal min-w-250",
      onInput: onChangingName
    }, null, 8, ["modelValue"]),
    (__props.errorFields?.customerName)
      ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_.head(__props.errorFields.customerName)?.message), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})